import { invalidateExploreSummary } from '../explore/exploreRefresh';
import api from '../../api/api';
import { commentApi } from '../../api/comment';
export const playlistCommentsApi = {
  async listComments(id, sort, signal) {
    const response = await commentApi.getComments('play_list', id, sort, {
      signal,
      optionalAuth: true,
      suppressGlobalError: true,
    });
    return response.data ?? response;
  },
  async createComment(id, content, parent) {
    const response = await api.postAuth(
      '/comments',
      {
        articleType: 'PLAY_LIST',
        articleId: Number(id),
        content: content.trim(),
        parentId: parent?.id ?? null,
        mentionedUserId: parent?.user?.id ?? null,
      },
      { suppressGlobalError: true },
    );
    return response.data?.data ?? response.data;
  },
};
// These are the existing web query families, rather than the native key names.
export async function invalidatePlaylistConsumers(client) {
  await invalidateExploreSummary(client, 'playlist');
  return client.invalidateQueries({
    predicate: ({ queryKey }) => /playlist|lists|curator|discovery/i.test(String(queryKey[0])),
  });
}

export function removeDeletedPlaylist(client, id) {
  const remove = (cached) => {
    if (Array.isArray(cached)) return cached.filter((item) => String(item.id) !== String(id));
    if (!cached || typeof cached !== 'object') return cached;
    if (cached.pages) return { ...cached, pages: cached.pages.map(remove) };
    if (Array.isArray(cached.data)) return { ...cached, data: remove(cached.data) };
    return cached;
  };
  client.setQueriesData(
    {
      predicate: ({ queryKey }) =>
        ['browse-playlists', 'browse-my-playlists', 'browse-curator'].includes(queryKey[0]),
    },
    remove,
  );
}
